var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description-for-paid-membership-plan"},[(_vm.freeArea.description !== null)?_c('switch-by-ua',{attrs:{"content":_vm.freeArea.description}}):_c('i',{staticClass:"fas fa-spinner fa-spin"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }